/**
 * =====================================================================
 * apps/web/src/lib/browser-support.ts
 * =====================================================================
 * Detección barata de "navegador demasiado antiguo" para las SUPERFICIES
 * DE PAGO.
 *
 * El target de build de Vite 7 es `chrome107/edge107/firefox104/safari16`
 * (baseline-widely-available). Por debajo, el bundle puede no funcionar
 * (o funcionar a medias) y stripe.js puede fallar. En vez de polyfillizar
 * todo el stack, mostramos un aviso AMABLE y no bloqueante para que el
 * usuario actualice o cambie de navegador/dispositivo ANTES de perder la
 * venta (incidente Android 10 / Samsung Internet 30).
 *
 * Los marcadores son features estables cuya versión mínima se aproxima al
 * target de build:
 *   - Promise.allSettled      (Chrome 76, Safari 13, FF 71)
 *   - Object.hasOwn           (Chrome 93, Safari 15.4, FF 92)
 *   - structuredClone         (Chrome 98, Safari 15.4, FF 94)
 *   - fetch                   (Chrome 42, Safari 10.1, FF 39)
 * Si falta alguno → navegador por debajo del baseline → mostramos el aviso.
 *
 * NOTA: esto cubre el caso "bundle parsea pero faltan APIs". Si el navegador
 * es TAN antiguo que ni parsea el bundle, la pantalla queda en blanco y no
 * hay JS que pueda mostrar aviso (caso extremo, fuera de alcance de este
 * gate).
 * =====================================================================
 */

/**
 * ¿El navegador soporta el baseline de build (chrome107/safari16 aprox.)?
 * Devuelve `true` en entornos no-browser (SSR/tests) para no romper nada.
 */
export function isBrowserSupported(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return true;
  }
  try {
    return (
      typeof Promise !== "undefined" &&
      typeof Promise.allSettled === "function" &&
      typeof Object.hasOwn === "function" &&
      typeof structuredClone === "function" &&
      typeof fetch === "function"
    );
  } catch {
    return false;
  }
}
